import DeleteProfilePopover from '/component/partial/DeleteProfilePopover';

export const generateOpenDeletePopover = (
  popoverShow: any,
  handleDeleteProfile: any,
) => {
  return () => {
    popoverShow(DeleteProfilePopover, {
      onSubmit: () => handleDeleteProfile,
    });
  };
};
